import { getChannelByUrl } from '../config';

export const useIsTicketmaster = (): boolean => {
    const salesChannelConfig = getChannelByUrl(window.location.host);
    const isTicketmaster = salesChannelConfig?.sso === 'ticketmaster';

    return Boolean(isTicketmaster);
};
